// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-btn[data-v-1596ca76]{padding:0;color:#6c757d;cursor:pointer}.item-name[data-v-1596ca76]{vertical-align:7px;padding-left:1rem}.main-container[data-v-1596ca76]{margin-top:70px}", ""]);
// Exports
module.exports = exports;
